import { Dropdown } from 'antd';
import type { DropDownProps } from 'antd/es/dropdown';
import { createStyles } from 'antd-style';
import classNames from 'classnames';
import React from 'react';

const useStyles = createStyles(({ token }) => {
  return {
    dropdown: {
      [`@media screen and (max-width: ${token.screenXS}px)`]: {
        maxWidth: 'calc(100vw - 24px)',
      },
    },
  };
});

export type HeaderDropdownProps = {
  placement?:
    | 'bottomLeft'
    | 'bottomRight'
    | 'topLeft'
    | 'topCenter'
    | 'topRight'
    | 'bottomCenter';
} & Omit<DropDownProps, 'overlay'>;

const HeaderDropdown: React.FC<HeaderDropdownProps> = ({
  classNames: callerClassNames,
  ...restProps
}) => {
  const { styles } = useStyles();
  return <Dropdown {...restProps} classNames={(info) => {
    const supplied = typeof callerClassNames === 'function'
      ? callerClassNames(info) : callerClassNames;
    return {
      ...supplied,
      root: classNames(styles.dropdown,
        (restProps.popupRender || restProps.dropdownRender) && 'qm-custom-dropdown', supplied?.root),
    };
  }} />;
};

export default HeaderDropdown;
